<template>
  <div class="range-component" v-invalid="validation.is_valid">
    <div class="field" v-bind:class="getFieldClass(field.layout.layout_type)">
      <label
        class="label"
        v-if="field.label"
        :class="getLabelClass(field.layout.layout_type)"
        :for="field.id">
        <span>
          {{ field.label }}
        </span>
      </label>
      <div class="control"
           :class="getControlClass(field.layout.layout_type)">
        <range-slider-component
          :piecewise="true"
          :piecewiseLabel="true"
          :min="1"
          :max="10"
          :interval="1"
          :height="3"
          :data="[1,3,5,10]"
          v-model="formData.fields[field.id].value"
          v-on:input="onInputChange()"
          :id="field.id"
          :name="field.id"
          :readonly="field.properties.input_readonly">
        </range-slider-component>
        <p class="help is-danger"
           v-if="!validation.is_valid">
          {{ validation.message }}
        </p>
        <p class="help"
           v-if="field.properties.help_text"
           v-html="field.properties.help_text">
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import FormField from '@/classes/form/FormField'
  import FormData from '@/classes/form/FormData'
  import RangeSliderComponent from '@/components/layout/range_slider/RangeSliderComponent'

  export default {
    components: { RangeSliderComponent },
    name: 'range-component',
    props: {
      field: {
        type: FormField
      },
      formData: {
        type: FormData
      }
    },
    computed: {
      validation () {
        return this.formData.validations[this.field.id] || { is_valid: true }
      }
    },
    methods: {
      onInputChange () {
        this.formData.inputOnChange(this.field)
        this.formData.callbacks[this.field.id] && this.formData.callbacks[this.field.id]()
      },
      getFieldClass (layoutType) {
        return {
          'columns is-multiline is-mobile': layoutType === 'horizontal'
        }
      },
      getLabelClass (layoutType) {
        return {
          'column is-4': layoutType === 'horizontal'
        }
      },
      getControlClass (layoutType) {
        return {
          'column is-8': layoutType === 'horizontal'
        }
      }
    }
  }
</script>

<style lang="sass" scoped>

  label > li
    list-style-position: inside

</style>
